const createImagePath = (path: string) => `${process.env.PUBLIC_URL}/images/${path}`;
const createIconPath = (path: string) => `${process.env.PUBLIC_URL}/images/icons/${path}`;
export const Images = {
  Logo: createImagePath('logo.svg'),
  Footerlogo: createImagePath('footerlogo.svg'),
  Curve: createImagePath('curve.svg'),
  Exploreplayer: createImagePath('exploreplayer.png'),
  Explorebg: createImagePath('explorebg.jpg'),
  Goalkeeper: createImagePath('goalkeeper.jpg'), 
  Defenders: createImagePath('defenders.jpg'),  
  NoImage:createImagePath('no-image.jpeg'),
  Image:createImagePath('image.jpg'),
  
  Facebook: createIconPath('facebook.svg'),
  Twitter: createIconPath('twitter.svg'),
  Instagram: createIconPath('instagram.svg'),
  Youtube: createIconPath('youtube.svg'),
  Feat1: createIconPath('feat1.svg'),
  Feat2: createIconPath('feat2.svg'),
  Feat3: createIconPath('feat3.svg'),
  Feat4: createIconPath('feat4.svg'),
  Cup: createIconPath('cup.svg'), 
  Downarrow: createIconPath('downarrow.svg'),  
  Search: createIconPath('search.svg'),  
  Filtertoggle: createIconPath('filtertoggle.svg'), 
  Pgnext: createIconPath('pgnext.svg'), 
  Pgprev: createIconPath('pgprev.svg'), 
  Linkpop: createIconPath('linkpop.svg'),      
}